export default {
  emptyState() {
    this.replaceState({ survey_filter: null });
  },

  UPDATE(state, payload) {
    state.survey_filter = Object.assign(state.survey_filter, payload);
  },
};
